import React from "react";
import { useLandingT } from "@/lib/landingI18n";

const stats = [
  { key: "stat1", value: "142,000+", accent: "text-emerald-300" },
  { key: "stat2", value: "2.8s", accent: "text-white" },
  { key: "stat3", value: "$1,240", accent: "text-emerald-300" },
  { key: "stat4", value: "3,400+", accent: "text-white" },
];

export const StatBand = ({ lang }) => {
  const t = useLandingT(lang);
  return (
    <section className="relative py-10 border-y border-white/8 bg-white/[0.015]">
      <div className="max-w-[1240px] mx-auto px-5 md:px-8 grid grid-cols-2 md:grid-cols-4 gap-8">
        {stats.map((s) => (
          <div key={s.key} className="text-start">
            <p
              className={`tabular text-3xl md:text-4xl font-semibold tracking-tight ${s.accent}`}
            >
              {s.value}
            </p>
            <p className="mt-2 text-[11px] uppercase tracking-[0.14em] text-slate-400">
              {t(s.key)}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};
